// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3BY6o","text__input":"styles_text__input__2RRuC","search__icon":"styles_search__icon__3KF7m"};